import React from 'react';

import { DeviceContext } from '@/components/DeviceProvider/DeviceProvider';
import { mapUrl } from '@/logic/main/utils';
import { CategoryFinancialWebAttributes } from '@/types/category/categoryTypes';

import styles from './GameLink.module.scss';

interface GameLinkProps {
  target?: string;
  url: string;
  shouldMapUrl?: boolean;
  categoryAttributes?: CategoryFinancialWebAttributes;
  notIndexed?: boolean;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  className?: string;
  integration?: string;
  dataTestId?: string;
  children?: React.ReactNode;
  emptySpaceChar?: boolean;
};

const GameLink = ({
  target = '_blank',
  url,
  shouldMapUrl = true,
  onClick = () => {},
  integration = '',
  className = styles.anchor,
  children,
  dataTestId = 'game-link',
  notIndexed,
  emptySpaceChar = true,
  categoryAttributes,
}: GameLinkProps) => {
  const { deviceType, deviceOs } = React.useContext(DeviceContext);

  const linkUrl = shouldMapUrl
    ? mapUrl(url, deviceType, deviceOs, categoryAttributes)
    : url;

  const openerReferer = target === '_blank' ? 'noopener noreferrer ' : '';
  const noFollow = notIndexed ? 'nofollow' : '';

  return (
    <a
      className={className}
      data-testid={dataTestId}
      target={target}
      rel={`${openerReferer}${noFollow}`}
      href={linkUrl}
      // IMPORTANT: Do not update logic to handle game launch here, put everything into launchingGameController
      onClick={event => onClick(event)}
    >
      {emptySpaceChar && <span>&nbsp;</span>}
      {children}
    </a>
  );
};

export default GameLink;
